import PessoaService from "business/cadastro/pessoa/pessoa/pessoaService"
import { isValidCpf } from "helper/checker"
import { boolToNumber, toJSDate } from "helper/formater"
import * as yup from "yup"

export default class UsuarioService extends PessoaService {

    title = "Usuário"
    pluralTitle = "Usuários"
    url = '/cadastro/pessoa/usuario'
    frontUrl = '/cadastro/pessoa/usuario'
    frontUrlList = '/cadastro/pessoa/usuariolist'
    primaryKey = 'codigo_usu'
    ignoredsSchemaConvertions = ['cod_esco_pef', 'cod_hobb_pef', 'cod_esci_pef', 'cod_sexo_pef', 'cod_prof_pef', 'cod_grup_pes', 'cod_catp_pes', 'cod_clap_pes']
    count = 1

    prepareToFront(data = {}) {

        console.log("usuarioService:::PREPARETOFRONT():", this.count, data)


        data.usuario_empresa = data.usuario_empresa || []
        data.pessoa_fisica = data.pessoa_fisica || {}
        data.pessoa_fisica.pessoa = data.pessoa_fisica.pessoa || {}

        data.pessoa_fisica.pessoa.pessoa_endereco = data.pessoa_fisica.pessoa?.pessoa_endereco || []
        data.pessoa_fisica.pessoa.cli_atac_pes = data.pessoa_fisica.pessoa.cli_atac_pes || 0
        data.pessoa_fisica.emis_rg_pef = toJSDate(data.pessoa_fisica.emis_rg_pef)
        data.pessoa_fisica.nasc_pef = toJSDate(data.pessoa_fisica.nasc_pef)
        data.pessoa_fisica.renda_mes_pef = data.pessoa_fisica.renda_mes_pef || null

        if (data.pessoa_fisica.pessoa?.pessoa_endereco) {
            data.pessoa_fisica.pessoa.pessoa_endereco.forEach(e => {
                e.usa_desde_ende = toJSDate(e.usa_desde_ende)
            })
        }

        for (const usem of data.usuario_empresa) {

            if (usem.meta.pessoaJuridicaEmp) {
                usem.pessoaJuridicaEmp = usem.meta.pessoaJuridicaEmp
                delete usem.meta.pessoaJuridicaEmp
            }

            usem.cod_perf_usem = this.getElementPerfil(usem.perfil)

        }

        data.usuario_empresa.sort((a, b) => a.pessoaJuridicaEmp.nome_fantasia_pej.localeCompare(b.pessoaJuridicaEmp.nome_fantasia_pej))

        this.count++

        return data
    }

    prepareToSave({ data }) {

        data.pessoa_fisica.cod_esci_pef = data.pessoa_fisica.cod_esci_pef?.codigo_esci || null
        data.pessoa_fisica.cod_sexo_pef = data.pessoa_fisica.cod_sexo_pef?.codigo_sexo || null
        data.pessoa_fisica.cod_prof_pef = data.pessoa_fisica.cod_prof_pef?.codigo_prof || null
        data.pessoa_fisica.cod_esco_pef = data.pessoa_fisica.cod_esco_pef?.codigo_esco || null
        data.pessoa_fisica.cod_hobb_pef = data.pessoa_fisica.cod_hobb_pef?.codigo_hobb || null
        data.pessoa_fisica.pessoa.reter_iss_pes = boolToNumber(data.pessoa_fisica.pessoa.reter_iss_pes)
        data.pessoa_fisica.pessoa.cli_atac_pes = boolToNumber(data.pessoa_fisica.pessoa.cli_atac_pes)
        data.pessoa_fisica.pessoa.blq_venda_ate_pes = boolToNumber(data.pessoa_fisica.pessoa.blq_venda_ate_pes)
        data.pessoa_fisica.pessoa.cod_grup_pes = data.pessoa_fisica.pessoa.cod_grup_pes?.codigo_grup || null
        data.pessoa_fisica.pessoa.cod_catp_pes = data.pessoa_fisica.pessoa.cod_catp_pes?.codigo_catp || null
        data.pessoa_fisica.pessoa.cod_clap_pes = data.pessoa_fisica.pessoa.cod_clap_pes?.codigo_clap || null

        data.pessoa_fisica.pessoa.pessoa_endereco.forEach(e => {
            e.cod_tend_ende = e.cod_tend_ende.codigo_tend
            e.cod_muni_ende = e.cod_muni_ende.codigo_muni
        })

        data.usuario_empresa.forEach(e => {
            e.cod_perf_usem = e.cod_perf_usem.codigo_perf
            e.codigo_usem = e.codigo_usem > 0 ? e.codigo_usem : null
        })

        // Remove perfis não setados
        data.usuario_empresa = data.usuario_empresa.filter(e => e.cod_emp_usem > 0 || e.cod_perf_usem > 0)

        data.meta.urlconfirmUsu = window.location.origin

        delete data.pessoa_fisica.meta

        return data

    }

    async getById(args = {}) {

        args.includes = args.includes || 'usuario,pessoa_fisica,pessoa_endereco_tipo'

        return super.getById(args).then((response) => {
            // response.data = this.prepareToFront(response.data)
            console.log('BACKEND: ', response)
            return response
        })


    }

    async getSchema() {

        return super.getSchema().then((data) => {

            if (data.fields) {

                const pessoa = data.fields.pessoa_fisica.fields.pessoa.fields
                const endereco = data.fields.pessoa_fisica.fields.pessoa.fields.pessoa_endereco.innerType.fields

                pessoa.cpf_cnpj_pes = pessoa.cpf_cnpj_pes.test('cpf', 'Cpf incorreto!', isValidCpf)
                endereco.cod_tend_ende = yup.object().typeError('Obrigatório').required('Obrigatório')
                endereco.cod_muni_ende = yup.object()
                    .test('municipio', 'Inválido', e => e.codigo_muni)
                    .typeError('Obrigatório')
                    .required('Obrigatório')

            }
            console.log('Very Final yup1: ', data)

            return data

        })

    }

    static help() {
        return `Você cadastra o usuário aqui e depois de salvar ele 
        receberá um link no e-mail para fazer uma senha e concluir o 
        cadastro! Se o usuário já possui uma conta na plataforma ele
        apenas recebe um e-mail de acesso à uma nova Base de empresas. 
        Se o perfil da empresa não estiver ativo o usuário não conseguirá 
        acessar a empresa.`
    }

    getElementPerfil(perfil) {
        if (perfil) {
            return { codigo_perf: perfil.codigo_perf, descricao_perf: perfil.descricao_perf }
        }
        return { codigo_perf: undefined, descricao_perf: undefined }
    }

}
